import React from 'react';

import { JSONLDSchema } from './types';

export interface Props {
  data: Partial<JSONLDSchema> | Partial<JSONLDSchema>[];
}

/**
 * Component for rendering structured data in the document head
 */
export const StructuredData = ({ data }: Props): JSX.Element => (
  <script type="application/ld+json">{JSON.stringify(data)}</script>
);

export default StructuredData;
